export function mergeRecordsById<T extends { id: string }>(
  currentRecords: T[],
  incomingRecords: T[]
): T[] {
  const byId = new Map<string, T>();
  currentRecords.forEach((record) => byId.set(record.id, record));
  incomingRecords.forEach((record) => byId.set(record.id, record));
  return Array.from(byId.values());
}
